import React from "react";
//Packages
import { Container, Row, Col, Spinner } from "react-bootstrap";

const LoadingSpinner = () => {
  return (
    <Container className='mt-5 mb-5'>
      <Row>
        <Col className='d-flex justify-content-center'>
          <div className='text-center mt-4 mb-4' id='copyright'>
            <Spinner animation='grow' variant='primary' size='lg' />
            <p>...loading...</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default LoadingSpinner;
